/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} KindleInputs */

const en_kindle = /** @type {(inputs: KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle`)
};

const es_kindle = /** @type {(inputs: KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle`)
};

/**
* | output |
* | --- |
* | "Kindle" |
*
* @param {KindleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle = /** @type {((inputs?: KindleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<KindleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle(inputs)
	return en_kindle(inputs)
});